import { createContent } from "@altify/utils";

export const gainLossContent = createContent({
    en: {
        infoTitle: "Gain/Loss Calculation",
        infoText: "Total Portfolio Gain/Loss = Closing Portfolio Value + Withdrawals - Deposits - Opening Portfolio Value",
    },
    de: {
        infoTitle: "Gewinn/Verlust Berechnung",
        infoText: "Gesamter Portfolio Gewinn/Verlust = Endportfoliowert + Auszahlungen - Einzahlungen - Startportfoliowert",
    },
})